var map = {
	"./Content/ArtHack2023.jsx": 2449,
	"./Content/CTFs/AESCBCpiv.jsx": 810,
	"./Content/CTFs/InsaneBolt.jsx": 8099,
	"./Content/CTFs/SpacePirates.jsx": 6763,
	"./Content/GamesProject.jsx": 952,
	"./Content/JaneStreetRobotBaseball.jsx": 1552,
	"./Content/Update1.jsx": 3984,
	"./Media/CTFCode.jsx": 6554,
	"./Summary/ArtHack2023.jsx": 7274,
	"./Summary/Bpuzzled2023.jsx": 3017,
	"./Summary/BrisHack2023.jsx": 4189,
	"./Summary/BrisHack2024.jsx": 7699,
	"./Summary/CTFs/AESCBCpiv.jsx": 7802,
	"./Summary/CTFs/BAECTF2024.jsx": 2524,
	"./Summary/CTFs/InsaneBolt.jsx": 9070,
	"./Summary/CTFs/SpacePirates.jsx": 8007,
	"./Summary/GameJam2022.jsx": 3242,
	"./Summary/GameJam2023.jsx": 3253,
	"./Summary/GamesProject.jsx": 2495,
	"./Summary/Graphics.jsx": 213,
	"./Summary/Hackathon2022.jsx": 8194,
	"./Summary/JaneStreetRobotBaseball.jsx": 6403,
	"./Summary/JaneStreetShutTheBox.jsx": 1052,
	"./Summary/TailwindUpdate.jsx": 3374,
	"./Summary/Update1.jsx": 9834,
	"./UpdateContent.jsx": 3688,
	"./UpdateSummary.jsx": 713
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9391;